import React from 'react';

import { Subscriber } from 'react-broadcast';

import NotificationsList from './NotificationsList';

class NotificationsListWrapper extends React.Component {
  render() {
    return (
      <Subscriber channel="notifications">
        {notifications => <NotificationsList notifications={notifications} />}
      </Subscriber>
    );
  }
}


export default NotificationsListWrapper;



// WEBPACK FOOTER //
// ../src/client/components/NotificationsList/index.js